import { Box, ButtonIcon, ButtonPrimary, Flex } from 'front-end/src/components'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'
import { Trans, t, Plural } from '@lingui/macro'

import GroupAvatar from 'front-end/src/components/common/group/group-avatar/GroupAvatar'
import IconBan from 'front-end/src/components/common/icon/IconBan'
import TableExtendedOld from 'front-end/src/components/common/table-extended-old/TableExtendedOld'
import Tooltip from 'front-end/src/components/common/tooltip/Tooltip'
import { LinkableUserAvatar } from 'front-end/src/components/common/user/linkable-user-avatar/LinkableUserAvatar'
import React, { Component, ReactNode } from 'react'
import { Column } from 'react-table'
import { brandColors } from 'shared/basicPalette'
import { AccessBanner } from '../../../components/common/access-banner/AccessBanner'
import Loader from '../../../components/common/loader/Loader'
import { AccessModalMode } from '../../manage-pathways-page/components/GenericAccessModal'
import PathwayRemoveGroupModal from '../../manage-pathways-page/components/PathwayRemoveGroupModal'
import PathwayRemoveUserModal from '../../manage-pathways-page/components/PathwayRemoveUserModal'
import PathwayShareModal from '../../manage-pathways-page/components/PathwayShareModal'
import './AccessTab.less'
import {
  PathwayAccessGroupFragment,
  PathwayAccessUsersFragment
} from '../ManagePathwayPage.codegen'

interface IProps {
  loadingUsers: boolean
  loadingGroups: boolean
  pathwayUsers?: PathwayAccessUsersFragment | null
  pathwayGroups?: PathwayAccessGroupFragment[] | null
  pathwayPublic: boolean
  isPathwayPublished: boolean
  page: number
  pageSize: number
  onUsersOrderChange: (order: any) => void
  onGroupsOrderChange: (order: any) => void
  onPageChange: (page: number) => void
  onUsersChanged: () => void
  onGroupsChanged: () => void
  onSearchChange: (search: string) => void
  onPathwayPublicChanged: (isPublic: boolean) => void
}

interface IState {
  showRemoveUserModal: boolean
  showRemoveGroupModal: boolean
  removingUserId: number | null
  removingGroupId: number | null
  showShareModal: boolean
}

// TODO refactor to FC
export default class PathwayAccessTab extends Component<IProps, IState> {
  state = {
    showRemoveUserModal: false,
    showRemoveGroupModal: false,
    removingUserId: null,
    removingGroupId: null,
    showShareModal: false
  }

  handleShowRemoveUserModal = (removingUserId: number): void => {
    this.setState({
      removingUserId,
      showRemoveUserModal: true
    })
  }

  handleShowRemoveGroupModal = (removingGroupId: number): void => {
    this.setState({
      removingGroupId,
      showRemoveGroupModal: true
    })
  }

  handleRemoveUserModalCanceled = () => {
    this.setState({
      showRemoveUserModal: false
    })
  }

  handleRemoveGroupModalCanceled = () => {
    this.setState({
      showRemoveGroupModal: false
    })
  }

  handleRemoveUserModalDeleted = (): void => {
    this.setState({
      showRemoveUserModal: false
    })

    this.props.onUsersChanged()
  }

  handleRemoveGroupModalDeleted = (): void => {
    this.setState({
      showRemoveGroupModal: false
    })

    this.props.onGroupsChanged()
  }

  handleShareToggle = (showShareModal: boolean): void => {
    this.setState({
      showShareModal
    })
  }

  handleShareSubmitted = (): void => {
    const { onUsersChanged, onGroupsChanged } = this.props

    this.setState({
      showShareModal: false
    })

    onUsersChanged()
    onGroupsChanged()
  }

  render(): ReactNode {
    const {
      onPageChange,
      onUsersOrderChange,
      onGroupsOrderChange,
      onSearchChange,
      onPathwayPublicChanged,
      loadingUsers,
      loadingGroups,
      page,
      pageSize,
      pathwayUsers,
      pathwayGroups,
      pathwayPublic
    } = this.props

    const tableColumnsPeople: Column[] = [
      {
        Header: '',
        sortable: false,
        maxWidth: 54,
        Cell: (row) => {
          return <LinkableUserAvatar user={row.original} />
        }
      },
      {
        Header: t`Name`,
        accessor: 'display_name',
        Cell: (row) => {
          return (
            <Flex direction="column">
              <strong className="dark">{row.original.display_name}</strong>
              {row.original.email && (
                <Box fontSize={fontSizes.xs} color={brandColors.grey[500]}>
                  {row.original.email}
                </Box>
              )}
            </Flex>
          )
        }
      },
      {
        Header: '',
        accessor: 'action',
        maxWidth: 80,
        sortable: false,
        Cell: (row) => {
          return (
            <>
              <ButtonIcon
                color={brandColors.grey.mid}
                icon={<IconBan />}
                hint={t`Remove`}
                aria-label={t`Remove`}
                onClick={() => this.handleShowRemoveUserModal(row.original.id)}
              />
            </>
          )
        }
      }
    ]

    const tableColumnsGroups: Column[] = [
      {
        Header: '',
        sortable: false,
        maxWidth: 54,
        Cell: (row) => {
          return <GroupAvatar group={{ name: row.original.name }} />
        }
      },
      {
        Header: t`Name`,
        accessor: 'name',
        Cell: (row) => {
          return <strong className="dark">{row.original.name}</strong>
        }
      },
      {
        Header: '',
        accessor: 'users_count',
        sortable: false,
        Cell: (row) => {
          return (
            <Box color={brandColors.grey[500]}>
              <Plural
                value={row.original.usersCount}
                _0=""
                one="# Member"
                other="# Members"
              />
            </Box>
          )
        }
      },
      {
        Header: '',
        accessor: 'action',
        maxWidth: 80,
        sortable: false,
        Cell: (row) => {
          return (
            <>
              <ButtonIcon
                color={brandColors.grey.mid}
                icon={<IconBan />}
                hint={t`Remove`}
                aria-label={t`Remove`}
                onClick={() => this.handleShowRemoveGroupModal(row.original.id)}
              />
            </>
          )
        }
      }
    ]

    const {
      showShareModal,
      removingUserId,
      showRemoveUserModal,
      removingGroupId,
      showRemoveGroupModal
    } = this.state

    if ((loadingUsers && loadingGroups) || !pathwayGroups || !pathwayUsers) {
      return <Loader />
    }

    return (
      <>
        <Box className="ManagePathway__AccessTab" pb="48px">
          <AccessBanner
            subject={t`Pathway`}
            isPublic={pathwayPublic}
            onToggle={() => onPathwayPublicChanged(!pathwayPublic)}
            notePrivate={t`Note: People you share the pathway with will be automatically granted access.`}
          />

          <TableExtendedOld
            loading={loadingGroups}
            manual
            data={pathwayGroups}
            tableHeader={t`Groups`}
            tableDescription={t`All members of the following groups have access to this pathway`}
            columns={tableColumnsGroups}
            className="-highlight AnalyticsTable"
            minRows={0}
            defaultSorted={[
              {
                id: 'name',
                desc: false
              }
            ]}
            onSortedChange={onGroupsOrderChange}
            showPageSizeOptions={false}
            extendFilter={
              <Tooltip
                text={
                  !this.props.isPathwayPublished
                    ? t`You can't grant access to anyone until pathway is published.`
                    : null
                }
              >
                <ButtonPrimary
                  ml="12px"
                  disabled={!this.props.isPathwayPublished}
                  onClick={() => this.handleShareToggle(true)}
                >
                  <Trans>Add people and groups</Trans>
                </ButtonPrimary>
              </Tooltip>
            }
            resizable={false}
            showPagination={false}
          />
          <Box m="32px" />
          <TableExtendedOld
            loading={loadingUsers}
            manual
            data={pathwayUsers.users}
            tableHeader={t`People`}
            tableDescription={t`The following people have individual access to this pathway`}
            columns={tableColumnsPeople}
            className="-highlight AnalyticsTable"
            defaultPageSize={pageSize}
            minRows={0}
            showPageSizeOptions={false}
            showSearchFilter
            resizable={false}
            page={page}
            pages={Math.ceil(pathwayUsers.usersCount / pageSize)}
            defaultSorted={[
              {
                id: 'display_name',
                desc: false
              }
            ]}
            onSortedChange={onUsersOrderChange}
            onPageChange={onPageChange}
            onSearchChange={onSearchChange}
            paginationContentBefore={
              <Box fontSize={fontSizes.sm} color={brandColors.grey.mid}>
                <Trans>
                  {' '}
                  {pathwayUsers.usersCountWithoutFilter} people{` `}
                  {!!pathwayGroups.length ? (
                    <>and {pathwayGroups.length} groups </>
                  ) : null}
                  found
                </Trans>
              </Box>
            }
          />
        </Box>
        <PathwayRemoveUserModal
          userId={removingUserId}
          pathwayId={pathwayUsers.id}
          show={showRemoveUserModal}
          onCanceled={this.handleRemoveUserModalCanceled}
          onDeleted={this.handleRemoveUserModalDeleted}
        />
        <PathwayRemoveGroupModal
          groupId={removingGroupId}
          pathwayId={pathwayUsers.id}
          show={showRemoveGroupModal}
          onCanceled={this.handleRemoveGroupModalCanceled}
          onDeleted={this.handleRemoveGroupModalDeleted}
        />
        <PathwayShareModal
          show={showShareModal}
          pathwayId={pathwayUsers.id}
          onCancel={() => this.handleShareToggle(false)}
          onSubmitted={this.handleShareSubmitted}
          mode={AccessModalMode.ONLY_ACCESS}
        />
      </>
    )
  }
}
